import { useState } from 'react'

const SECTORS = [
  '', 'BTP / Construction', 'Commerce / Distribution', 'Conseil / Audit',
  'Finance / Banque / Assurance', 'Immobilier', 'Industrie / Manufacture',
  'Informatique / Tech', 'Juridique', 'Marketing / Communication',
  'Restauration / Hôtellerie', 'Santé / Médical', 'Services aux entreprises',
  'Transport / Logistique', 'Autre',
]

function buildQuery({ jobTitle, location, sector, quantity }) {
  const parts = []
  if (quantity && parseInt(quantity) > 1) parts.push(`${quantity}`)
  if (jobTitle) parts.push(jobTitle)
  if (location) parts.push(`à ${location}`)
  if (sector) parts.push(`dans le secteur ${sector}`)
  return parts.join(' ').trim()
}

export default function ProspectsSearchBox({ onSearch, loading }) {
  const [isExpanded, setIsExpanded] = useState(false)
  const [form, setForm] = useState({ jobTitle: '', location: '', sector: '', quantity: '5' })

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!form.jobTitle.trim()) return
    const query = buildQuery(form)
    onSearch(query, parseInt(form.quantity) || 5, form)
  }

  const handleCancel = () => {
    setIsExpanded(false)
    setForm({ jobTitle: '', location: '', sector: '', quantity: '5' })
  }

  const preview = buildQuery(form)

  return (
    <div className="inline-search-box">
      <p className="search-hint">Trouvez vos prospects idéaux par métier et localisation</p>

      {!isExpanded && (
        <div className="search-collapsed">
          <button className="minimal-search-btn" onClick={() => setIsExpanded(true)} type="button">
            <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
              <path d="M10 2L12.5 7.5L18 10L12.5 12.5L10 18L7.5 12.5L2 10L7.5 7.5L10 2Z" fill="currentColor" />
            </svg>
            <span>Rechercher des prospects...</span>
            <kbd className="kbd-hint">⌘K</kbd>
          </button>
        </div>
      )}

      {isExpanded && (
        <form onSubmit={handleSubmit} className="search-expanded">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 10 }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
              <label style={{ fontSize: 11, color: 'rgb(var(--rgb-ink) / 0.45)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Métier / Poste *</label>
              <input
                name="jobTitle"
                value={form.jobTitle}
                onChange={handleChange}
                placeholder="Ex: Chef d'entreprise, CTO, DRH..."
                autoFocus
                required
                style={{ background: 'rgb(var(--rgb-ink) / 0.05)', border: '1px solid rgb(var(--rgb-ink) / 0.12)', borderRadius: 8, padding: '8px 12px', color: 'var(--color-text)', fontSize: 13, outline: 'none' }}
              />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
              <label style={{ fontSize: 11, color: 'rgb(var(--rgb-ink) / 0.45)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Localisation</label>
              <input
                name="location"
                value={form.location}
                onChange={handleChange}
                placeholder="Ex: Paris, Lyon, Île-de-France..."
                style={{ background: 'rgb(var(--rgb-ink) / 0.05)', border: '1px solid rgb(var(--rgb-ink) / 0.12)', borderRadius: 8, padding: '8px 12px', color: 'var(--color-text)', fontSize: 13, outline: 'none' }}
              />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
              <label style={{ fontSize: 11, color: 'rgb(var(--rgb-ink) / 0.45)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Secteur</label>
              <select
                name="sector"
                value={form.sector}
                onChange={handleChange}
                style={{ background: '#1a1a2e', border: '1px solid rgb(var(--rgb-ink) / 0.12)', borderRadius: 8, padding: '8px 12px', color: form.sector ? '#fff' : 'rgba(255,255,255,0.3)', fontSize: 13, outline: 'none' }}
              >
                <option value="">Tous secteurs</option>
                {SECTORS.filter(Boolean).map((s) => <option key={s} value={s}>{s}</option>)}
              </select>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
              <label style={{ fontSize: 11, color: 'rgb(var(--rgb-ink) / 0.45)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Quantité souhaitée</label>
              <input
                name="quantity"
                type="number"
                min="1"
                max="100"
                value={form.quantity}
                onChange={handleChange}
                style={{ background: 'rgb(var(--rgb-ink) / 0.05)', border: '1px solid rgb(var(--rgb-ink) / 0.12)', borderRadius: 8, padding: '8px 12px', color: 'var(--color-text)', fontSize: 13, outline: 'none' }}
              />
            </div>
          </div>

          {preview && (
            <div style={{ marginBottom: 10, padding: '8px 12px', borderRadius: 8, background: 'rgba(91, 92, 244,0.05)', border: '1px solid rgba(91, 92, 244,0.15)', fontSize: 12, color: 'rgb(var(--rgb-ink) / 0.5)' }}>
              <span style={{ color: 'rgba(91, 92, 244,0.7)', marginRight: 6 }}>Requête :</span>
              <span style={{ fontStyle: 'italic' }}>{preview}</span>
            </div>
          )}

          <div className="search-actions">
            <button className="search-action-btn btn-secondary" type="button" onClick={handleCancel}>
              Annuler
            </button>
            <button className="search-action-btn btn-enrich" type="submit" disabled={loading || !form.jobTitle.trim()}>
              {loading ? 'Recherche...' : 'Rechercher'} <kbd>↵</kbd>
            </button>
          </div>
        </form>
      )}
    </div>
  )
}
